// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_1tUnK{--rootPadding:0px}@media only screen and (min-width:768px){.root_1tUnK{--rootPadding:0px 0px 15px}}.root_1tUnK{margin:0 auto;max-width:1200px;padding:var(--rootPadding)}.imageHalf_hVQBy{width:50%}.square_VbrdV{margin:0 auto;width:100%;max-width:375px}.imageWrapper_en0-k{position:relative;padding-top:100%}.image_j\\+MQn{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.content_yxCfy{display:flex;align-items:stretch;width:100%}.innerContent_lXWU8{display:flex;flex-direction:column;justify-content:center;flex:1;max-width:none;padding:0 15px}.result_A91TQ{display:flex;align-items:center;margin-bottom:10px}.summary_oIC6-{margin:10px 0;font-weight:300}.percentage_3xTzj{flex-shrink:0;width:50px;color:#7123d9;font-weight:700;font-size:20px;line-height:150%;text-align:center}.resultText_mqEis{margin-left:12px;font-weight:400;font-size:14px;line-height:20px}.report_V9PhR{display:flex;justify-content:center}.reportLink_RNWHb{color:#272525;font-size:14px;font-weight:600;line-height:150%;text-align:center;-webkit-text-decoration-line:underline;text-decoration-line:underline;text-transform:uppercase}", ""]);
// Exports
exports.locals = {
	"root": "root_1tUnK",
	"imageHalf": "imageHalf_hVQBy",
	"square": "square_VbrdV",
	"imageWrapper": "imageWrapper_en0-k",
	"image": "image_j+MQn",
	"content": "content_yxCfy",
	"innerContent": "innerContent_lXWU8",
	"result": "result_A91TQ",
	"summary": "summary_oIC6-",
	"percentage": "percentage_3xTzj",
	"resultText": "resultText_mqEis",
	"report": "report_V9PhR",
	"reportLink": "reportLink_RNWHb"
};
module.exports = exports;
